import { useQuery } from '@apollo/client';
import BodyTitle from '@firsttable/web-components/atoms/BodyTitle';
import { Table, THead, TBody, Tr, Th, Td } from '@firsttable/web-components/atoms/Table';
import type { ReactNode } from 'react';
import { GET_LOYALTY_EARN_DEFINITIONS } from './loyaltyQueries';
import { ErrorHandler } from '../ErrorBoundary/ErrorBoundary';

const LoyaltyTierEarnDefinitions = ({
  renderHtml,
}: {
  renderHtml: (html: string) => ReactNode;
}) => {
  const { data, loading, error } = useQuery(GET_LOYALTY_EARN_DEFINITIONS, {
    variables: {
      siteId: process.env.NEXT_PUBLIC_SITE_ID,
    },
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <ErrorHandler error={error} />;
  }

  return (
    <>
      <Table style={{ width: '100%' }}>
        <THead>
          <Tr>
            <Th>Activity</Th>
            <Th textAlign="center">Points</Th>
          </Tr>
        </THead>
        <TBody>
          {data.earnDefinitions.map((definition) => (
            <Tr key={definition.id}>
              <Td>
                <BodyTitle fontSize={17} my={10} fontWeight="600">
                  {definition.title}
                </BodyTitle>
                {renderHtml(definition.marketingDescription)}
              </Td>
              <Td textAlign="center">{definition.points}</Td>
            </Tr>
          ))}
        </TBody>
      </Table>
    </>
  );
};

export default LoyaltyTierEarnDefinitions;
